<template>
  <main-frame>
    <router-view/>
  </main-frame>
</template>

<script>
import MainFrame from './Frame'

export default {
  name: 'MainLayout',
  components: {
    MainFrame,
  },
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Main.vue